(function () {
  angular
    .module("akitabox.desktop.asset.detail")
    .controller("AssetSchedulesTabController", AssetSchedulesTabController);

  /* @ngInject */
  function AssetSchedulesTabController(
    // Angular
    $scope,
    // Constants
    EVENT_SCHEDULE_CREATE,
    MAINTENANCE_SCHEDULE_STATUS_ACTIVE,
    // Service
    ScheduleService,
    ToastService,
    // Resolve
    building,
    asset
  ) {
    var self = this;

    // Attributes
    self.building = building;
    self.asset = asset;
    self.schedules = null;
    self.status = MAINTENANCE_SCHEDULE_STATUS_ACTIVE;
    self.createOptions = getCreateOptions();

    // Functions
    self.fetchSchedules = fetchSchedules;
    self.fetchAllSchedules = fetchAllSchedules;

    // ------------------------
    //   Events
    // ------------------------

    $scope.$on(EVENT_SCHEDULE_CREATE, onScheduleCreate);

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchSchedules(skip, limit) {
      var params = {
        skip: skip,
        limit: limit,
        asset: self.asset._id,
        status: self.status,
      };

      return ScheduleService.get(building._id, params)
        .then(function (schedules) {
          if (angular.isArray(self.schedules)) {
            self.schedules = self.schedules.concat(schedules);
          } else {
            self.schedules = schedules;
          }
          return schedules.length;
        })
        .catch(ToastService.showError);
    }

    function fetchAllSchedules(limit) {
      var params = {
        skip: 0,
        limit: limit,
        asset: self.asset._id,
        status: self.status,
      };

      return ScheduleService.getAll(building._id, params)
        .then(function (schedules) {
          self.schedules = schedules;
          return schedules.length;
        })
        .catch(ToastService.showError);
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function getCreateOptions() {
      return {
        locals: {
          building: building,
          floors: asset.level ? [asset.level] : null,
          rooms: asset.room ? [asset.room] : null,
          assets: [asset],
        },
      };
    }

    /**
     * Handle schedule creation event
     *
     * @param {Event}       $event      Angular event
     * @param {Schedule[]}  schedules   List of new schedules
     */
    function onScheduleCreate($event, schedules) {
      for (var i = 0; i < schedules.length; ++i) {
        var schedule = schedules[i];
        if (!schedule.asset) {
          continue;
        }
        var assetId = Object.prototype.hasOwnProperty.call(
          schedule.asset,
          "_id"
        )
          ? schedule.asset._id
          : schedule.asset;
        if (assetId === self.asset._id) {
          if (!self.schedules) {
            self.schedules = [];
          }
          self.schedules.unshift(schedules[i]);
        }
      }
    }
  }
})();
